
import { useService } from '../../JOKI';

export function useNotifications(showClosed=false) {

    const [notifications] = useService("NotificationService");
    
    if(!showClosed && notifications !== null) {
        return notifications.filter(note => note.closed !== true);
    }

    return notifications;
}

